import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import { Input } from "@babackapp/ui/components/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { useRef, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

type SearchMode = "email" | "orderId";

export default function SearchInput() {
  const { updateSearchEmail, updateSearchOrderId } = useReturnRequestsFilters();
  const [mode, setMode] = useState<SearchMode>("email");
  const inputRef = useRef<HTMLInputElement>(null);

  const debouncedEmail = useDebouncedCallback((value: string) => {
    updateSearchEmail({ searchEmail: value || undefined });
  }, 400);

  const debouncedOrderId = useDebouncedCallback((value: string) => {
    updateSearchOrderId({ searchOrderId: value || undefined });
  }, 400);

  const handleModeChange = (newMode: SearchMode) => {
    updateSearchEmail({ searchEmail: undefined });
    updateSearchOrderId({ searchOrderId: undefined });
    debouncedEmail.cancel();
    debouncedOrderId.cancel();
    if (inputRef.current) inputRef.current.value = "";
    setMode(newMode);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (mode === "email") {
      debouncedEmail(value);
    } else {
      debouncedOrderId(value);
    }
  };

  return (
    <div className="flex h-10 items-center rounded-md border border-input bg-background shadow-xs focus-within:ring-1 focus-within:ring-ring">
      <Select value={mode} onValueChange={handleModeChange}>
        <SelectTrigger className="w-28 h-full rounded-r-none border-0 border-r shadow-none focus:ring-0 text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="email">Email</SelectItem>
          <SelectItem value="orderId">Order ID</SelectItem>
        </SelectContent>
      </Select>
      <Input
        ref={inputRef}
        placeholder={
          mode === "email" ? "customer@example.com" : "#1234 or order ID"
        }
        className="h-full w-52 rounded-none rounded-r-md border-0 shadow-none focus-visible:ring-0"
        onChange={handleInputChange}
      />
    </div>
  );
}
